import { createTrackingUtils } from "../index";
import useProfiler from "hooks/useProfiler";
import { useEffect } from "react";

const utils = createTrackingUtils({
  name: "flights_web_sr_gen_ai_summary_v2_ddot_us",
  stages: {
    direct: 2,
    meta: 3,
    solo: 4,
    nonSolo: 5,
    children: 6
  },
  goals: {
    ctaClick: 1,
    loading: 2,
    success: 3,
    error: 4
  },
  defaultStage: 1
});

const useTrackStages = (isEligible: boolean) => {
  const { stages } = utils;
  const { isDirect, isMeta, isSolo, isWithKids } = useProfiler();

  useEffect(() => {
    if (!isEligible) {
      return;
    }

    isDirect() && stages.direct();
    isMeta() && stages.meta();
    isSolo() ? stages.solo() : stages.nonSolo();
    isWithKids() && stages.children();
  }, [isEligible, stages, isDirect, isMeta, isSolo, isWithKids]);
};

export default { ...utils, useTrackStages };
